import { render, staticRenderFns } from "./PayTypeGrid.vue?vue&type=template&id=3d64e9aa"
import script from "./PayTypeGrid.vue?vue&type=script&lang=js"
export * from "./PayTypeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports